import { DecisionContext, DecisionTypeHandler, DbotEventDispatcher } from "../common/commonDomain";
import { NoAuditor, NoAuditorForm } from "./noAuditorDomain";
import { DecisionType } from "../../common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext,
): NoAuditorForm {
  return new NoAuditorForm(context);
}

export function handleEvent() {}

export function isValid(): boolean {
  return true;
}

export function validate(): boolean {
  return true;
}

export function applyForm(): NoAuditor {
  return {
    type: DecisionType.noAuditor,
  };
}

export const noAuditorHandler: DecisionTypeHandler<
  DecisionType.noAuditor,
  NoAuditor,
  NoAuditorForm
> = {
  type: DecisionType.noAuditor,
  initNewForm,
  handleEvent,
  isValid,
  validate,
  applyForm,
};
